<template>
    <div class="order_bak2" v-portal>
        <div class="bai_bk" >
            <div class="bk_title">
                <span>《模型编写视频教程》线上视频课订单</span><img src="../../../assets/images/X_01.png" alt="" class="cha" @click="close">
            </div>
            <div style="height:400px;box-shadow: 0 6px 8px 0px #e5e5e5 inset; ">
                <scrollbar :config="config">
                    <div class="txt_block">
                        <div class="block_block">
                            <div class="title1">订课人</div>
                            <div class="text1">电话: {{$store.state.phone}}</div>
                        </div>
                        <div class="block_block">
                            <div class="title1">课程内容</div>
                            <div class="text1" v-for="(item,index) in allCousre" :key="index">
                                {{item}}
                            </div>
                            <div class="text1">课程类型: 线上视频；</div>
                            <div class="text1">有效期限: 自{{starDate}}至{{endDate}}，期间可无限次线上观看。</div>
                        </div>
                        <div class="block_block">
                            <div class="title1">积分兑换</div>
                            <div class="text1">本次使用{{needPoint}}积分，兑换{{courseli}}讲课程。</div>
                        </div>
                        <div class="block_block">
                            <div class="title1">重要声明</div>
                            <div class="text1">1、本视频课兑换成功后，不退、不换。</div>
                            <div class="text1">2、订课方不得将线上课程传播、复制，如有发现订课方有非法操作，我司有权取消订课方线上观看课程的权力，并不需退还相关费用（积分）。</div>
                            <div class="text1">3、本公司不对所提供的课程内容做任何形式的承诺与保证，课程内容仅作参考。</div>
                            <div class="text1">4、本课程依据我司 <common-data name="appShortName_11"/>（V8.6.131版本）软件做演示，本公司有权对<common-data name="appShortName_11"/>软件进行升级、并不需通知订课方，我司尽量使用最新版本做示例在线上课程中展示，但不保证与最新版内容一致。</div>
                            <div class="text1">5、如因不可抗力等非订课方原因导致无法正常观看课程，可与课程提供方协商解决办法。</div>
                        </div>
                        <div class="block_block">
                            <div class="text_name">
                                <div class="text1">星格量化投资技术研究所(苏州)有限公司</div>
                                <div class="text1">{{starDate}}</div>
                            </div>
                        </div>
                    </div>
                </scrollbar>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            config:{},
            courseli:0,
            starDate:'',
            endDate:'',
            allCousre:[],
        }
    },
    props:{
        needPoint:{
            type:Number,
            default:0
        },
        course:{
            type:Array,
            default:[]
        },

    },
    methods:{
        close(){
            this.$emit('textclose',false)
        },
        returnMonth(x){
            return Number(x)+1
        }
    },
    created(){
        this.$store.state.courselist.forEach((el,idx)=>{
            el.Courses.forEach((els,idxs)=>{
                if(this.course.includes(els.product_subid)){
                    this.courseli=this.courseli+1
                    this.allCousre.push(els.productname)
                }
            })
        })
        let day1 = new Date()
        this.starDate = day1.getFullYear()+'年' + this.returnMonth(day1.getMonth())+'月'+day1.getDate()+'日'
        day1.setFullYear(day1.getFullYear()+ 1);
        day1.setDate(day1.getDate()-1);
        this.endDate = day1.getFullYear()+'年' + this.returnMonth(day1.getMonth())+'月'+day1.getDate()+'日'

    },
    directives: {
        portal: {
        //自定义指令用于外层渲染
        inserted: function (el, binding) {
            var value = binding.value;
            console.log(binding);
            var app = document.querySelector("#app");
            try {
            if (value) {
                typeof value == "string"
                ? document.querySelector(value).appendChild(el)
                : value.appendChild(el);
            } else app.appendChild(el);
            } catch (error) {
            console.log(error);
            }
        },
        },
    },
}
</script>

<style scoped>
.order_bak2{
    position: fixed;
    background: rgba(0, 0, 0, 0.4);
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 10000;
}
.bai_bk{
    position: fixed;
    left: 50%;
    top: 35%;
    transform: translate(-50%, -50%);
    width: 570px;
    background: white;
    border-radius: 5px;
}
.bk_title{
    text-align: center;
    color: #666666;
    font-size: 16px;
    height: 45px;
    line-height: 45px;
    position: relative;
    font-weight: bold;
}
.cha{
    position: absolute;
    top: 15px;
    right: 15px;
    cursor: pointer;
}
.txt_block{
    padding: 12px 20px;
    /* box-shadow: 0 6px 8px 0px #e5e5e5 inset;  */
}
.block_block{
    margin-bottom:20px ;
}
.title1{
    font-weight: bold;
    color:#333333 ;
    font-size: 14px;
    line-height: 20px;
}
.text1{
    font-size: 14px;
    color: #666666;
    line-height: 18px;
}
.text_name{
    text-align: right;
}
</style>